import { createEffect } from 'effector'
import { DefaultsAPI } from '../../services/api/Defaults'
import { APIError, APIResult } from '../../core/api/Result'

export const $getDefaults = createEffect<unknown, APIResult<typeof DefaultsAPI['getDefaults']>, APIError>(
  DefaultsAPI.getDefaults,
)

export const $getUser = createEffect<unknown, APIResult<typeof DefaultsAPI['getUser']>, APIError>(
  DefaultsAPI.getUser,
)
